module.exports = __webpack_public_path__ + "img/graph_2.320f356e.png";